import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { currentYear } from "../utils/Date.util";
import { getCategories } from "../services/categories.services";

const Footer = () => {
    const [categories, setCategories] = useState([]);

    const fetchCategories = async () => {
        const categories = await getCategories();
        setCategories(categories);
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    return (
        <footer
            className="footer-wrapper footer-layout1"
            data-bg-src="assets/img/bg/footer_bg_1.png"
        >
            <div className="widget-area">
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-md-6 col-xl-3">
                            <div className="widget footer-widget">
                                <div className="th-widget-about">
                                    <div className="about-logo">
                                        <a href="home-newspaper.html">
                                            <img
                                                src="assets/img/RedLine-Logo.png"
                                                alt="Tnews"
                                            />
                                        </a>
                                    </div>
                                    <p className="about-text">
                                        Magazines cover a wide subjects,
                                        including not limited to fashion,
                                        lifestyle, health, politics, business,
                                        Entertainment, sports, science,
                                    </p>
                                    <div className="th-social style-black">
                                        <a href="https://www.facebook.com/">
                                            <i className="fab fa-facebook-f"></i>
                                        </a>
                                        <a href="https://www.twitter.com/">
                                            <i className="fab fa-twitter"></i>
                                        </a>
                                        <a href="https://www.linkedin.com/">
                                            <i className="fab fa-linkedin-in"></i>
                                        </a>
                                        <a href="https://www.whatsapp.com/">
                                            <i className="fab fa-whatsapp"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-auto">
                            
                        </div>
                        <div className="col-md-6 col-xl-3">
                            
                        </div>
                        <div className="col-md-6 col-xl-auto">
                            <div className="widget widget_nav_menu footer-widget">
                                <h3 className="widget_title">Categories</h3>
                                <div className="menu-all-pages-container">
                                    <ul className="menu">
                                        {categories.map((category, index) => {
                                            return (
                                                <li key={index}>
                                                    <NavLink
                                                        to={`/category/${category.name}`}
                                                        state={{
                                                            name: category.name,
                                                        }}
                                                    >
                                                        {category.name}
                                                    </NavLink>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright-wrap">
                <div className="container">
                    <div className="row jusity-content-between align-items-center">
                        <div className="col-lg-5">
                            <p className="copyright-text">
                                Copyright <i className="fal fa-copyright"></i>{" "}
                                {currentYear}{" "}
                                <a href="home-newspaper.html">RedLines</a>. All
                                Rights Reserved.
                            </p>
                        </div>
                        <div className="col-lg-auto ms-auto d-none d-lg-block">
                            <div className="footer-links">
                                <ul>
                                    <li>
                                        <a href="home-newspaper.html">Home</a>
                                    </li>
                                    <li>
                                        <a href="about.html">About Us</a>
                                    </li>
                                    <li>
                                        <NavLink to="privacy-policy">
                                            Privacy Policy
                                        </NavLink>
                                    </li>
                                    <li>
                                        <a href="contact.html">Contact Us</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
